import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { hasEmailSignatureContent, sanitizeEmailSignatureHtml } from './email-signature-html';

@Component({
    selector: 'vf-email-signature-paste-dialog',
    templateUrl: './email-signature-paste-dialog.component.html',
    styleUrls: ['./email-signature-paste-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmailSignaturePasteDialogComponent implements OnChanges {
    @Input() value = '';
    @Input() saving = false;
    @Input() errorMessage = '';
    @Output() valueChange = new EventEmitter<string>();
    @Output() saveRequested = new EventEmitter<void>();
    @Output() cancelRequested = new EventEmitter<void>();

    previewHtml = '';
    hasContent = false;
    isEmpty = true;
    removesSignature = false;
    saveDisabled = true;
    desktopPreviewSelected = true;
    mobilePreviewSelected = false;

    // The dialog is created per edit, so the first value is the signature it was opened with. Clearing that
    // signature and saving is how a user removes it.
    private openedWithSignature = false;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value && changes.value.firstChange) {
            this.openedWithSignature = hasEmailSignatureContent(sanitizeEmailSignatureHtml(this.value || ''));
        }
        this.updatePreview(this.value);
    }

    onDraftChange(html: string): void {
        const cleanHtml = sanitizeEmailSignatureHtml(html || '');
        this.value = cleanHtml;
        this.updatePreview(cleanHtml);
        this.valueChange.emit(cleanHtml);
    }

    showDesktopPreview(): void {
        this.desktopPreviewSelected = true;
        this.mobilePreviewSelected = false;
    }

    showMobilePreview(): void {
        this.desktopPreviewSelected = false;
        this.mobilePreviewSelected = true;
    }

    requestCancel(): void {
        if (!this.saving) {
            this.cancelRequested.emit();
        }
    }

    requestSave(): void {
        if (!this.saveDisabled) {
            this.saveRequested.emit();
        }
    }

    private updatePreview(html: string): void {
        const cleanHtml = sanitizeEmailSignatureHtml(html || '');
        this.hasContent = hasEmailSignatureContent(cleanHtml);
        this.isEmpty = !this.hasContent;
        this.removesSignature = this.isEmpty && this.openedWithSignature;
        this.saveDisabled = this.saving || (this.isEmpty && !this.openedWithSignature);
        this.previewHtml = this.hasContent ? cleanHtml : '';
    }
}
